export const SIBLING_BEFORE = 'SIBLING_BEFORE'
export const SIBLING_AFTER = 'SIBLING_AFTER'
export const CHILD_FIRST = 'CHILD_FIRST'
export const CHILD_LAST = 'CHILD_LAST'